/**
 * Безопасно извлекает сообщение об ошибке из unknown.
 * Используется в stores для обработки catch-блоков.
 */
export function getErrorMessage(e: unknown, fallback: string): string {
  if (e instanceof Error) return e.message;
  if (typeof e === 'object' && e !== null && 'message' in e) {
    const msg = (e as { message?: string }).message;
    if (typeof msg === 'string' && msg.length > 0) return msg;
  }
  return fallback;
}
